// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { CompareFooterService } from '@coa/app/shared/select-items-shared/services/compare-footer.service';
import {
  namesRequested,
  namesRequestError,
  namesRequestSuccess,
} from '@coa/app/shared/select-items-shared/store/compare-footer.actions';

@Injectable()
export class CompareFooterEffects {

  storesRequested$ = createEffect(() =>
    this.actions$.pipe(
      ofType(namesRequested),
      switchMap((action) => this.compareFooterService.getNames(action.clientId, action.selectableFeature).pipe(
        map((compareNamesResponse) => namesRequestSuccess({compareNamesResponse})),
        catchError(() => of(namesRequestError())),
      )),
    ),
  );

  constructor(
    private actions$: Actions,
    private store$: Store,
    private compareFooterService: CompareFooterService) {
  }
}
